import React, { Component, ReactNode } from 'react';
import AdminAuditsComponent from './AdminAuditsComponent';
import LoginAuditsComponent from './LoginAuditsComponent';
import CustomSelect from '../../custom/CustomSelect';
import ComponentAudits from './ComponentAudits';
import ExportImportAuditsComponent from './ExportImportAuditsComponent';
import LanguageUtil from '../../../util/LanguageUtil';

class AuditManagementContainer extends Component<{}, State> {
  public state = new State();

  public render(): ReactNode {
    const { auditLogType } = this.state;
    return (
      <div className={'flex flex-col w-full h-full overflow-y-hidden px-5 py-5'}>
        <div className={'flex w-full items-center justify-end'}>
          <div className={'flex mr-3'}>
            <CustomSelect
              value={auditLogType}
              onChange={(e) => {
                this.setState({ auditLogType: e.value });
              }}
              options={[
                { label: LanguageUtil.get({ id: 'pages.admin.audit.management.adminLabel', defaultMessage: 'Admin' }), value: 'Admin' },
                { label: LanguageUtil.get({ id: 'pages.admin.audit.management.loginLabel', defaultMessage: 'Login' }), value: 'Login' },
                { label: LanguageUtil.get({ id: 'pages.admin.audit.management.componentLabel', defaultMessage: 'Component' }), value: 'Component' },
                {
                  label: LanguageUtil.get({ id: 'pages.admin.audit.management.exportImportLabel', defaultMessage: 'Export/Import' }),
                  value: 'ExportImport',
                },
              ]}
            />
          </div>
        </div>
        {this.getAuditPage()}
      </div>
    );
  }

  public getAuditPage() {
    const { auditLogType } = this.state;
    switch (auditLogType) {
      case 'Admin':
        return <AdminAuditsComponent />;
      case 'Login':
        return <LoginAuditsComponent />;
      case 'Component':
        return <ComponentAudits />;
      case 'ExportImport':
        return <ExportImportAuditsComponent />;
      default:
        return <AdminAuditsComponent />;
    }
  }
}

class State {
  auditLogType: 'Admin' | 'Login' | 'Component' | 'ExportImport' = 'Admin';
}

export default AuditManagementContainer;
